<template>
  <div class="secondPage">
    <el-form ref="firstForm" :model="firstForm" label-position="top" :rules="firstRules">
      <el-form-item label="任务名称" prop="name" v-if="aiModel===1">
        <el-input :style="formItemStyle" v-model="firstForm.name"></el-input>
      </el-form-item>
      <el-form-item label="选择客户" prop="customerId" v-if="aiModel === 2">
        <el-select :style="formItemStyle" v-model="firstForm.customerId" placeholder="请选择客户"
                   @change="customerChange"
                   :clearable="true"
                   :filterable="true"
                   value-key="serviceId">
          <el-option v-for="item in customerList" :key="item.serviceId" :label="item.custName+ '——' + item.serviceCode"
                     :value="item"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="secondForm" :model="secondForm" label-position="top" :rules="secondRules">

      <el-form-item label="请确认每个产品的信息是否合适" v-if="aiModel === 2" v-loading="productLoading">
        <div v-show="productList.length===0&&productTypeList.length===0" style="color: #F56C6C;">
          请先选择客户
        </div>
        <div>

          <el-button
              v-for="(product, index) in productList"
              :key="product.productId"
              :type="secondForm.productId===product.productId?'primary': ''"
              @click="tagClick(product,index)"
              :disabled="canChangeProduct"
              size="mini"
          >
            {{ product.title }}
          </el-button>
          <el-button
              v-for="(productType, index) in productTypeList"
              :key="productType.productTypeId"
              :type="secondForm.productTypeId===productType.productTypeId?'primary': ''"
              @click="tagClick(productType,index)"
              :disabled="canChangeProduct"
              size="mini"
          >
            {{ productType.title }}
          </el-button>
        </div>
      </el-form-item>

      <el-row>
        <el-col :span="8">
          <el-form-item label="生成关键词" prop="aiKeywordFlag">
            <el-switch
                v-model="secondForm.aiKeywordFlag"
                :active-value="1"
                :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生成广告标题" prop="aiTitleFlag">
            <el-switch
                v-model="secondForm.aiTitleFlag"
                :active-value="1"
                :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生成广告说明" prop="aiDescFlag">
            <el-switch
                v-model="secondForm.aiDescFlag"
                :active-value="1"
                :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="产品网址">
        <el-input :style="formItemStyle" v-model="secondForm.pagePath"></el-input>
      </el-form-item>
      <el-form-item prop="aiKeywordList">
        <template slot="label">
          <span>产品核心关键词</span>
          <el-link :underline="false" type="primary" style="float: right" @click="aiGenerateKeyword"
                   :disabled="aiKeywordLoading">
            {{ aiKeywordLoading ? '正在生成' : 'AI生成' }}
          </el-link>
        </template>
        <el-input :style="formItemStyle" type="textarea" :autosize="true" v-model="aiKeyword"></el-input>
      </el-form-item>
      <el-form-item prop="aiDesc">
        <template slot="label">
          <span>产品描述</span>
          <el-link :underline="false" type="primary" style="float: right" @click="descSummarize"
                   :disabled="descSummarizeLoading">{{ descSummarizeLoading ? '总结中' : 'AI总结' }}
          </el-link>
          <el-link :underline="false" type="primary" style="float: right;margin-right: 20px;" :disabled="aiDescLoading"
                   @click="aiGenerateDesc">{{ aiDescLoading ? '正在生成' : 'AI生成' }}
          </el-link>
        </template>
        <el-input :style="formItemStyle" type="textarea" :autosize="true" v-model="secondForm.aiDesc"></el-input>
      </el-form-item>
      <!--高级设置-->
      <el-collapse v-model="activeName" :accordion="true" @change="openClose">
        <el-collapse-item name="first">
          <template slot="title">
            <div class="more-title">
              <el-link icon="el-icon-s-tools" :underline="false" :type="activeName==='first'?'primary': 'info'">
                高级设置
              </el-link>
            </div>
          </template>
          <el-form-item label="补充说明">
            <el-input :style="formItemStyle" type="textarea" v-model="secondForm.aiIllustrate"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="输出语言">
                <el-select :style="formItemStyle" v-model="secondForm.aiLanguage" :clearable="false"
                           placeholder="请选择" :filterable="true">
                  <el-option v-for="item in languageList" :key="item.criterionId" :label="item.languageNameZh"
                             :value="item.criterionId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="使用语气">
                <el-select :style="formItemStyle" v-model="secondForm.aiToneType" :clearable="false"
                           placeholder="请选择">
                  <el-option label="正式" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品优势">
                <el-select :style="formItemStyle" v-model="secondForm.productAdvantageList" :multiple="true"
                           placeholder="请选择">
                  <el-option v-for="item in extraData.descProductAdvantageList" :key="item.id"
                             :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务优势">
                <el-select :style="formItemStyle" v-model="secondForm.serviceAdvantageList" :multiple="true"
                           placeholder="请选择">
                  <el-option v-for="item in extraData.descServiceAdvantageList" :key="item.id"
                             :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销语">
                <el-select :style="formItemStyle" v-model="secondForm.salesSlogansList" :multiple="true"
                           placeholder="请选择">
                  <el-option v-for="item in extraData.descPromotionList" :key="item.id"
                             :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工厂优势">
                <el-select :style="formItemStyle" v-model="secondForm.factoryAdvantageList" :multiple="true"
                           placeholder="请选择">
                  <el-option v-for="item in extraData.descFactoryAdvantageList" :key="item.id"
                             :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="号召性用语">
                <el-select :style="formItemStyle" v-model="secondForm.callOutList" :multiple="true"
                           placeholder="请选择">
                  <el-option v-for="item in extraData.descCalloutList" :key="item.id"
                             :label="item.content + ' - ' + item.enContent" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-form-item>
        <el-button type="primary" @click="submitForm()" style="margin-top: 20px;">开 始</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {mapState, mapMutations} from "vuex";
import sem from '@/backend/services/sem/sem.js';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';

export default {
  name: 'secondPage',
  data() {
    return {
      formItemStyle: {
        width: '80%'
      },
      activeName: '', // 高级设置
      firstForm: {
        name: '',
        customerId: ''
      },
      firstRules: {
        name: [{required: true, message: '请输入任务名称', trigger: 'change'},],
        customerId: [{required: true, message: '请选择客户', trigger: 'change'},],
      },
      secondForm: {
        "aiDesc": "",
        "aiDescFlag": 0,
        "aiIllustrate": "",
        "aiKeywordList": [],
        "aiKeywordFlag": 0,
        "aiLanguage": 1000,
        "aiTitleFlag": 0,
        "aiToneType": 1,
        "callOutList": [],
        "factoryAdvantageList": [],
        "pagePath": "",
        "productAdvantageList": [],
        "salesSlogansList": [],
        "serviceAdvantageList": [],
        "title": "string",
      },
      secondRules: {
        aiKeywordList: [{required: false, message: '请输入产品核心关键词', trigger: 'change'},],
        aiDesc: [{required: false, message: '请输入产品描述', trigger: 'change'},],
      },
      customerList: [], //客户列表options
      productList: [], // 产品列表
      productTypeList: [],// 产品分类列表
      extraData: {
        descCalloutList: [], //号召性用语集合
        descFactoryAdvantageList: [], // 工厂优势集合
        descProductAdvantageList: [], // 产品优势集合
        descPromotionList: [],// 促销语集合
        descServiceAdvantageList: [], // 服务优势集合
      },
      productLoading: false, // 请求产品loading状态
      languageList: [], // 语言列表
      currentCustomer: {}, // 当前选中的客户
      customerInfo: {
        automationId: '', // ads新户自动化信息ID
        programmeId: '', // ai广告方案信息ID
        serviceId: '', // 服务单ID
        customerId: '', // 客户ID
      },// 当前客户信息
      aiKeyword: '', // 产品核心关键词 --- 表单显示用，最终要转换为字符串数组
      aiKeywordLoading: false, // 生成关键词loading
      aiDescLoading: false, // 生成产品描述loading
      descSummarizeLoading: false, // 产品描述总结loading

    }
  },
  computed: {
    ...mapState({
      aiModel: state => state.aiAds.aiModel,
      currentInfo: state => state.aiAds.currentInfo
    }),
    canChangeProduct() {
      return this.aiKeywordLoading || this.aiDescLoading || this.descSummarizeLoading;
    }
  },
  watch: {
    aiKeyword: {
      handler(val) {
        if (val) {
          // 关键词输入时，转换为字符串数组，去重、去掉空字符串元素
          this.secondForm.aiKeywordList = [...new Set(val.split('\n'))].filter(item => item !== "")
        }
      }
    },
    secondForm: {
      handler(val) {
        // 当选择了 关键期 ， 产品核心关键词必填
        this.secondRules.aiKeywordList[0].required = !!val.aiKeywordFlag;
        // 当选择了 广告标题 || 广告说明 ，产品描述必填
        this.secondRules.aiDesc[0].required = !!(val.aiTitleFlag || val.aiDescFlag);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getCustomerList();
    this.getInfo();
  },

  methods: {
    // 从历史记录、第三页退回时，请求产品信息
    getInfo() {
      if (this.currentInfo.programmeId || (this.currentInfo.customerId && this.currentInfo.serviceId)) {
        let param = {
          programmeId: this.currentInfo.programmeId,
          serviceId: this.currentInfo.serviceId, // 服务单ID
          customerId: this.currentInfo.customerId, // 客户ID
        };
        this.getProductList(param)
      }
    },
    // 产品描述AI总结
    async descSummarize() {
      this.aiDescLoading = true;
      this.$notify.info({
        title: 'AI总结产品描述',
        message: '正在总结，请稍后...'
      });
      let param = {}
      param = {
        content: this.secondForm.aiDesc
      }
      let res = await sem.descSummarize(param);
      this.aiDescLoading = false;
      this.secondForm.aiDesc = res.data;
      this.$notify({
        title: 'AI总结产品描述',
        message: '产品描述总结完成！',
        type: 'success'
      });
    },
    // AI生成产品描述
    async aiGenerateDesc() {
      this.aiDescLoading = true;
      this.$notify.info({
        title: 'AI生成产品描述',
        message: '正在生成，请稍后...'
      });
      let param = {}
      if (this.aiModel === 1) {
        param = {
          pagePath: this.secondForm.pagePath
        }
      } else if (this.aiModel === 2) {
        param = {
          customerId: this.firstForm.customerId.customerId,
          pagePath: this.secondForm.pagePath,
          serviceId: this.customerInfo.serviceId
        };
      }
      let res = await sem.secondPageDesc(param);
      this.aiDescLoading = false;
      this.secondForm.aiDesc = res.data;
      this.$notify({
        title: 'AI生成产品描述',
        message: '产品描述已生成！',
        type: 'success'
      });
    },
    // AI生成产品核心关键词
    async aiGenerateKeyword() {
      this.aiKeywordLoading = true;
      this.$notify.info({
        title: 'AI生成关键词',
        message: '正在生成，请稍后...'
      });
      let param = {}
      if (this.aiModel === 1) {
        param = {
          pagePath: this.secondForm.pagePath
        }
      } else if (this.aiModel === 2) {
        param = {
          customerId: this.firstForm.customerId.customerId,
          pagePath: this.secondForm.pagePath,
          serviceId: this.customerInfo.serviceId
        };
      }
      let res = await sem.secondPageKeyword(param);
      this.aiKeywordLoading = false;
      this.aiKeyword = res.data.join('\n')
      this.$notify({
        title: 'AI生成关键词',
        message: '关键词已生成！',
        type: 'success'
      });
    },
    // 重置表单2方法
    resetSecondForm() {
      // 重置当前用户信息
      this.customerInfo = {
        automationId: '', // ads新户自动化信息ID
        programmeId: '', // ai广告方案信息ID
        serviceId: '', // 服务单ID
        customerId: '', // 客户ID
      };
      // 重置表单2信息
      this.secondForm = {
        "aiDesc": "",
        "aiDescFlag": 0,
        "aiIllustrate": "",
        "aiKeywordList": "",
        "aiKeywordFlag": 0,
        "aiLanguage": 1000,
        "aiTitleFlag": 0,
        "aiToneType": 1,
        "callOutList": [],
        "factoryAdvantageList": [],
        "pagePath": "",
        "productAdvantageList": [],
        "salesSlogansList": [],
        "serviceAdvantageList": [],
        "title": "",
      }
    },
    // 切换客户
    customerChange(value) {
      // 先清空一下产品
      this.productTypeList = [];
      this.productList = [];
      // 重置表单2
      this.resetSecondForm();
      // 请求客户产品
      let param = {
        customerId: value.customerId,
        programmeId: undefined,
        serviceId: value.serviceId
      }
      this.getProductList(param);
    },
    // 请求客户产品
    async getProductList(param) {
      this.productLoading = true;
      try {
        let res = await sem.productInfo(param);
        this.productList = res.data.productList;
        this.productTypeList = res.data.productTypeList;
        this.customerInfo.automationId = res.data.automationId;  // ads新户自动化信息ID
        this.customerInfo.programmeId = res.data.programmeId; // ai广告方案信息ID
        this.customerInfo.serviceId = res.data.serviceId; // 服务单ID
        this.customerInfo.customerId = res.data.customerId; // 客户ID
        this.productLoading = false;
        // 第一部分表单赋值
        this.firstForm.name = res.data.programmeName;
        setTimeout(() => {

          this.firstForm.customerId = {
            customerId: res.data.customerId,
            serviceId: res.data.serviceId
          };
        }, 1000)
        // 默认选择第一个产品
        if (this.productList.length > 0) {
          this.tagClick(this.productList[0])
        } else if (this.productTypeList.length > 0) {
          this.tagClick(this.productTypeList[0])
        }
      } catch (e) {
        this.productLoading = false;
      }

    },
    // 请求客户
    async getCustomerList() {
      let res = await sem.listCustomer();
      this.customerList = res.data;
    },
    // 高级设置展开/收起
    openClose() {
      if (this.activeName) {
        this.getMontageContent(2);
        this.adLanguage();// 请求语言列表
      }
    },
    // 请求高级信息
    async getMontageContent(ruleType) {
      let res = await adsNewOnlineSer.getmontagecontent({
        ruleType
      })
      this.extraData = res.data;
    },
    // 请求语言列表
    async adLanguage() {
      let res = await adsNewOnlineSer.adLanguage();
      this.languageList = res.data;
    },
    // 选择产品
    tagClick(product) {
      this.secondForm = product;
      // 切换产品时，将关键词输入框清空
      this.aiKeyword = '';
      // 如果产品有关键词，则置入
      if (product.aiKeywordList.length) {
        this.aiKeyword = product.aiKeywordList.join('\n')
      }
    },
    // 提交接口
    async addProgramme(param) {
      // 如果store中有主任务id，带上，就是编辑了
      if (this.currentInfo.programmeId) {
        this.customerInfo.programmeId = this.currentInfo.programmeId
      }
      let res = await sem.addProgramme(param);
      this.setCurrentPage(3)

      this.customerInfo.programmeId = res.data;
      this.setCurrentInfo(this.customerInfo);// 将客户信息等父级信息存入store，给第三页用；

    },
    // 提交
    submitForm() {
      if(this.secondForm.aiDescFlag||this.secondForm.aiKeywordFlag||this.secondForm.aiTitleFlag){
        this.$refs.firstForm.validate((valid) => {
          if (valid) {
            console.log('表单1校验通过')
            this.$refs.secondForm.validate(valid => {
              if (valid) {
                console.log('表单2校验通过')
                let param = {}
                if (this.aiModel === 1) {
                  param = {
                    ...this.customerInfo,
                    name: this.firstForm.name, // 任务名称
                    productList: [this.secondForm],// 产品列表
                    productTypeList: [], // 产品分类列表
                  }
                } else if (this.aiModel === 2) {

                  param = {
                    ...this.customerInfo,
                    name: undefined, // 任务名称
                    productList: this.productList,// 产品列表
                    productTypeList: this.productTypeList, // 产品分类列表
                  }
                }
                this.addProgramme(param);
              } else {
                console.log('表单2校验失败')
              }
            })
          } else {
            console.log('表单1校验失败');
            return false;
          }
        });
      }else{
        this.$message.error('请至少选择一个生成内容！')
      }

    },
    ...mapMutations(['setCurrentPage', 'setCurrentInfo'])
  }
}
</script>
<style lang="scss">
.secondPage {
  .el-form-item__label {
    width: 80%;
  }

  .el-tag {
    margin-right: 10px;
  }
}
</style>